export default __webpack_public_path__ + "static/media/dimg9.4c26abbe.jpg";